import {
  AccountBalanceOutlined,
  AttachMoneyOutlined,
  CreditCardOutlined,
  FavoriteBorderOutlined,
  SavingsOutlined,
  TrendingUpOutlined,
} from "@mui/icons-material";
import { amber, blue, green, purple, teal } from "@mui/material/colors";

export const LIQUIDITY_SOURCE_TYPES = {
  CASH: "Cash",
  BROKERAGE: "Brokerage",
  LIFE_INSURANCE: "Life Insurance",
  OTHER_LOC: "Other Line of Credit",
  CASH_OUT_PROCEEDS: "Cash Out Proceeds",
};

export const LIQUIDITY_SOURCE_META = {
  [LIQUIDITY_SOURCE_TYPES.CASH]: {
    label: "Cash Liquidity",
    shortLabel: "Cash",
    description: "Checking, savings, money market balances.",
    color: green[600],
    iconBg: green[50],
    Icon: SavingsOutlined,
  },
  [LIQUIDITY_SOURCE_TYPES.BROKERAGE]: {
    label: "Brokerage Account",
    shortLabel: "Brokerage",
    description: "Taxable investment / securities accounts.",
    color: blue[700],
    iconBg: blue[50],
    Icon: TrendingUpOutlined,
  },
  [LIQUIDITY_SOURCE_TYPES.LIFE_INSURANCE]: {
    label: "Life Insurance Policy",
    shortLabel: "Life Insurance",
    description: "Cash surrender value of whole / universal policy.",
    color: purple[600],
    iconBg: purple[50],
    Icon: FavoriteBorderOutlined,
  },
  [LIQUIDITY_SOURCE_TYPES.OTHER_LOC]: {
    label: "Other Line of Credit",
    shortLabel: "Line of Credit",
    description: "HELOC, business LOC, or other undrawn credit lines.",
    color: amber[800],
    iconBg: amber[50],
    Icon: CreditCardOutlined,
  },
  [LIQUIDITY_SOURCE_TYPES.CASH_OUT_PROCEEDS]: {
    label: "Cash Out Proceeds",
    shortLabel: "Cash Out",
    description: "Net proceeds borrower receives at closing (refi cash-out).",
    color: teal[700],
    iconBg: teal[50],
    Icon: AttachMoneyOutlined,
  },
};

export const LIQUIDITY_SOURCE_OPTIONS = Object.values(
  LIQUIDITY_SOURCE_TYPES,
).map((v) => ({
  value: v,
  label: LIQUIDITY_SOURCE_META[v].label,
}));

export const sourceRequiresAssociations = (sourceType) =>
  sourceType !== LIQUIDITY_SOURCE_TYPES.CASH_OUT_PROCEEDS;

export const getSourceMeta = (sourceType) =>
  LIQUIDITY_SOURCE_META[sourceType] || LIQUIDITY_SOURCE_META.CASH;
